// src/redux/sessionSlice.js
import { createSlice } from '@reduxjs/toolkit'
import { ISession } from '../types'
import { setCookie } from 'cookies-next'

const initialState: ISession = {
  mobileAd: true,
  caniuseCookies: true,
  permissions: { geolocation: 'pending' },
  offHours: false,
  crm_table_number: '',
  crm_table_id: '',
  is_hall: '',
  branch_id: '',
  shipper_id: '',
  platform_id: '',
  menu_id: '',
  fcm_token: '',
  chat_id: '',
  source: '',
  order_type: null,
  device_id: '',
  shipper: null,
  shipperResolved: false,
}

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    closeAd: (state) => {
      state.mobileAd = false
    },
    // Save anything to session state
    save: (state, action) => {
      Object.assign(state, action.payload)
    },
    useCookies: (state) => {
      state.caniuseCookies = false
    },
    setOffHours: (state) => {
      state.offHours = true
    },
    acceptPGL: (state) => {
      state.permissions.geolocation = 'accepted'
    },
    rejectPGL: (state) => {
      state.permissions.geolocation = 'rejected'
    },
    resetPGL: (state) => {
      state.permissions.geolocation = 'pending'
    },
    saveOrderType: (state, action) => {
      state.order_type = action.payload
      setCookie('delivery_type', action.payload?.type, {
        maxAge: 30 * 24 * 60 * 60,
        path: '/',
      })
    },
  },
})

export default sessionSlice.reducer
export const sessionActions = sessionSlice.actions
